import { CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './se-accordion.css.lit';
import { OutlineAccordion } from '../../base/outline-accordion/outline-accordion';
/**
 * Accordion Component
 * @element se-accordion
 * @slot label: The title text for the accordion component.
 * @slot panels: For se-accordion-panels only.
 */
@customElement('se-accordion')
export class SeAccordion extends OutlineAccordion {
  static styles: CSSResultGroup = [componentStyles];
}

declare global {
  interface HTMLElementTagNameMap {
    'se-accordion': SeAccordion;
  }
}
